import { useDispatch, useSelector } from "react-redux";
import NotificationSnackbar from "../components/Shared/Snackbar";
import { hideNotification } from "../redux/slices/notificationSlice";

const NotificationWrapper = ({ children }) => {
  const dispatch = useDispatch();
  const notification = useSelector((state: { notification }) => state.notification);
  const handleSnackbarClose = () => {
    dispatch(hideNotification());
  };

  return (
    <>
      <NotificationSnackbar
        open={notification.open}
        onClose={handleSnackbarClose}
        message={notification.message}
        severity={notification.severity}
        horizontal={notification.horizontal}
        title={notification.title}
      />
      {children}
    </>
  );
};

export default NotificationWrapper;
